import { render, staticRenderFns } from "./selectClient.vue?vue&type=template&id=57256c27&scoped=true"
import script from "./selectClient.vue?vue&type=script&lang=js"
export * from "./selectClient.vue?vue&type=script&lang=js"
import style0 from "./selectClient.vue?vue&type=style&index=0&id=57256c27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57256c27",
  null
  
)

export default component.exports